import constant from './constant'

const dictionary = new Map([
  [constant.LOGIN_TITLE, 'Log in'],
  [constant.LOGIN, 'Log in'],
  [constant.LOGIN_NOT_A_MEMBER, 'Not a member?'],
  [constant.LOGIN_LABEL_EMAIL, 'Email'],
  [constant.LOGIN_LABEL_PASSWORD, 'Finnomena account password'],
  [constant.LOGIN_BTN_NEXT, 'Continue'],
  [constant.LOGIN_BTN_BACK, 'back'],
  [constant.LOGIN_WITH_SOCIAL, 'Log in with'],
  [constant.LOGIN_VERIFY_IDENTITY, 'Please verify your identity using the following methods to log in.'],
  [
    constant.LOGIN_HAS_ACCOUNT_VERIFY_IDENTITY,
    'This email is already associated with a Finnomena account. Please verify your identity using one of the following methods to sign in and link your account.'
  ],
  [constant.LOGIN_FORGOT_PASSWORD, 'Forgot your password?'],
  [constant.LOGIN_ERROR, 'An error occurred.'],
  [constant.LOGIN_ERROR_INCORRECT_PASSWORD, 'The password is incorrect. Want to '],
  [constant.LOGIN_ERROR_ACCOUNT_LOCKED, 'Account locked due to incorrect password entered 10 times in a row. Please '],
  [constant.LOGIN_ERROR_RESET_PASSWORD, 'reset your password'],
  [constant.LOGIN_ERROR_WRONG_PASSWORD, 'The password is incorrect.'],

  [constant.FORGOTPASSWORD_TITLE, "Don't know the password"],
  [constant.FORGOTPASSWORD_SUB_TITLE, "We'll email you a link to change your password."],
  [constant.FORGOTPASSWORD_BTN_SEND_RESET_LINK, 'Send password change link'],

  [constant.FORGOTPASSWORD_SENT_TITLE, 'A password reset link has been sent.'],
  [constant.FORGOTPASSWORD_SENT_SUBTITLE_A, 'Please check your email'],
  [
    constant.FORGOTPASSWORD_SENT_SUBTITLE_B,
    'for instructions on how to change your password, and complete the process within 30 minutes.'
  ],
  [constant.FORGOTPASSWORD_SENT_BTN, 'Back to sign in'],

  [constant.REGISTER_TITLE, 'Register'],
  [constant.REGISTER, 'Register'],
  [constant.REGISTER_ALREADY_HAS_ACCOUNT, 'Already a member?'],
  [constant.REGISTER_LABEL_EMAIL, 'Email'],
  [constant.REGISTER_LABEL_PASSWORD, 'Password'],
  [constant.REGISTER_LABEL_PASSWORD_AGAIN, 'Password again'],
  [constant.REGISTER_PASSWORD_MIN_LENGTH, 'Minimum length 8 digits'],
  [constant.REGISTER_PASSWORD_CRITERIA, 'Consist of a mix of English letters and numbers'],
  [
    constant.REGISTER_TC_ACKNOWLEDGEMENT,
    "By clicking 'Register' you acknowledge that you have read and accept Finnomena's"
  ],
  [constant.REGISTER_TC_TERMS_OF_USE, 'Terms of Use'],
  [constant.REGISTER_TC_AND, 'and'],
  [constant.REGISTER_TC_PRIVACY_POLICY, 'Privacy'],
  [
    constant.REGISTER_TC_OPT_OUT_MSG,
    '. You can opt out of receiving investment news and various benefits on the Profile page on Finnomena.com'
  ],

  [constant.DIVIDER_OR, 'or'],
  [constant.CONTACT_US, 'Contact Us'],
  [constant.INPUT_SHOW, 'show'],
  [constant.INPUT_HIDE, 'hide'],
  [constant.EMAIL, 'Email'],
  [constant.EMAIL_ALT, 'For Finnomena member account'],
  [constant.BACK, 'back'],
  [constant.BACK_HOMEPAGE, 'Return to home page'],
  [constant.PERIOD, '.'],


  [constant.ERROR_EMAIL_REQUIED, 'Please enter email'],
  [constant.ERROR_EMAIL_INVALID, 'Please enter a valid email address.'],
  [constant.ERROR_EMAIL_EXIST, 'This email is already exist.'],
  [constant.ERROR_EMAIL_IN_USE, 'This email is already in use. Have a problem using it?'],
  [constant.ERROR_EMAIL_NOT_MEMBER, 'This email has never been a Finnomena member.'],
  [constant.ERROR_PASSWORD_REQUIRED, 'Please enter your password.'],
  [constant.ERROR_PASSWORD_MIN_LENGTH, 'Minimum 8 characters'],
  [
    constant.ERROR_PASSWORD_WRONG_PATTERN,
    'At least 8 characters, including a mix of English letters, numbers, and at least 1 special character'
  ],
  [constant.ERROR_PASSWORD_MISMATCH, "Passwords don't match"],
  [constant.ERROR_OCCURRED, 'An error occurred.'],
  [constant.ERROR_OCCURRED_SOCIAL, 'An error occurred.'],

  [constant.SUCCESS_TITLE, 'Registration completed.'],
  [constant.SUCCESS_REDIRECT_TEXT, 'Redirecting you back to Finnomena in'],
  [constant.SUCCESS_DESC_CHECK_EMAIL, "Don't forget to check your email"],
  [constant.SUCCESS_DESC_INFO, 'for member information and'],
  [constant.SUCCESS_DESC_PRIVILEGE, 'exclusive privileges from Finnomena.'],

  [constant.EMAILSUCCESS_TITLE, 'Email confirmed'],
  [constant.EMAILSUCCESS_SUBTITLE, ' is verified.'],
  [constant.EMAILSUCCESS_REDIRECT_TEXT, 'Taking you back to Finnomena in'],
  [constant.EMAILSUCCESS_REDIRECT_LINK, 'Click here if the page has not been changed.'],

  [constant.RESETPASSWORD, 'Change password'],
  [constant.RESETPASSWORD_LABEL_EMAIL, 'Email'],
  [constant.RESETPASSWORD_LABEL_PASSWORD, 'Password'],
  [constant.RESETPASSWORD_LABEL_PASSWORD_AGAIN, 'Password again'],
  [constant.RESETPASSWORD_LABEL_OLD_PASSWORD_DUPLICATED, 'The password you entered matches your old password. Please choose a new password.'],

  [constant.RESETPASSWORD_SUCCESS_TITLE, 'Password changed successfully.'],
  [constant.RESETPASSWORD_SUCCESS_SUBTITLE_A, "You're all set! You can sign in right away with"],
  [constant.RESETPASSWORD_SUCCESS_SUBTITLE_B, ' '],

  [constant.RESETPASSWORD_EXPIRED_SUBTITLE, 'This password reset link has expired. Please request a new one.'],
  [constant.RESETPASSWORD_EXPIRED_BTN, 'Request a password reset'],

  [constant.INELIGIBLE_BTN, 'Open a mutual fund account with Finnomena'],

  [constant.INCIDENT_TITLE, 'Unable to log in with Facebook.'],
  [
    constant.INCIDENT_DESC,
    'For security reasons, Facebook on Android devices can only be used to sign in with the latest version of the Finnomena app, and only if the Facebook app is installed on your device.'
  ],
  [constant.INCIDENT_DESC_UPDATE, 'Update the Finnomena app and install the Facebook app to access normally.'],
  [constant.INCIDENT_OR, 'or'],
  [constant.INCIDENT_REGISTER, 'Sign up with email'],
  [constant.INCIDENT_ALREADY_HAS_ACCOUNT, 'Already have a Finnomena account? Please'],
  [constant.INCIDENT_LOGIN, 'sign in with your email and password.'],
  [
    constant.INCIDENT_FORGOT_PASSWORD,
    'If you already have an account but forgot your password, please reset your password to'
  ],
  [constant.INCIDENT_RESET_PASSWORD, 'set a new one.']
])

export default dictionary
